import * as Sentry from '@sentry/react'

function ErrorFallback({ error, resetError }: { error: Error; resetError: () => void }) {
  const isDev = import.meta.env.DEV

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <div className="w-full max-w-md rounded-lg border border-border bg-card p-8 text-center shadow-lg">
        <h2 className="mb-2 text-2xl font-bold text-foreground">Algo deu errado</h2>
        <p className="mb-6 text-muted-foreground">
          Ocorreu um erro inesperado. Por favor, tente novamente.
        </p>

        {isDev && error && (
          <pre className="mb-6 overflow-auto rounded bg-muted p-4 text-left text-xs text-destructive">
            {error.message}
            {error.stack && `\n\n${error.stack}`}
          </pre>
        )}

        <button
          onClick={resetError}
          className="rounded-md bg-primary px-6 py-2 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
        >
          Tentar novamente
        </button>
      </div>
    </div>
  )
}

export function AppErrorBoundary({ children }: { children: React.ReactNode }) {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <ErrorFallback error={error as Error} resetError={resetError} />
      )}
      showDialog
    >
      {children}
    </Sentry.ErrorBoundary>
  )
}
